import { render } from "./AppVipsDialog.vue?vue&type=template&id=78e57bb4&scoped=true&ts=true"
import script from "./AppVipsDialog.vue?vue&type=script&lang=ts"
export * from "./AppVipsDialog.vue?vue&type=script&lang=ts"

import "./AppVipsDialog.vue?vue&type=style&index=0&id=78e57bb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e57bb4"]])

export default __exports__